var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-transfer',{staticClass:"custom-transfer",attrs:{"data":_vm.data},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }